import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Linkedin } from 'lucide-react';

export const Footer: React.FC = () => {
  // Función para hacer scroll al inicio de la página
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <footer className="w-full relative overflow-hidden bg-gradient-to-r from-purple-950 via-indigo-950 to-purple-950">
      {/* Efecto de malla futurista */}
      <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PHBhdHRlcm4gaWQ9ImdyaWQiIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgcGF0dGVyblVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+PHBhdGggZD0iTSAwIDEwIEwgMjAgMTAgTSAxMCAwIEwgMTAgMjAiIHN0cm9rZT0iIzgwODBmZjEwIiBzdHJva2Utd2lkdGg9IjEiLz48L3BhdHRlcm4+PC9kZWZzPjxyZWN0IHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiIGZpbGw9InVybCgjZ3JpZCkiLz48L3N2Zz4=')] opacity-10"></div>
      
      {/* Borde superior brillante */}
      <div className="absolute top-0 left-0 right-0 h-[1px] bg-gradient-to-r from-purple-600/0 via-purple-600/50 to-purple-600/0"></div>
      
      <div className="container mx-auto px-4 py-6 md:py-12 pb-20 md:pb-12 relative z-10">
        {/* Sección de redes sociales centrada - Visible solo en móvil */}
        <div className="flex justify-center mb-6 md:hidden">
          <div className="flex space-x-6">
            <a href="https://www.instagram.com/curvia.app/" target="_blank" rel="noopener noreferrer" className="bg-purple-900/50 p-2 rounded-full hover:bg-purple-700/70 transition duration-300">
              <Instagram className="w-4 h-4 text-purple-300" />
            </a>
            <a href="https://www.tiktok.com/@curvia.ai" target="_blank" rel="noopener noreferrer" className="bg-purple-900/50 p-2 rounded-full hover:bg-purple-700/70 transition duration-300">
              <svg className="w-4 h-4 text-purple-300" viewBox="0 0 24 24" fill="currentColor">
                <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"/>
              </svg>
            </a>
            <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="bg-purple-900/50 p-2 rounded-full hover:bg-purple-700/70 transition duration-300">
              <Linkedin className="w-4 h-4 text-purple-300" />
            </a>
          </div>
        </div>
        
        {/* Layout de dos columnas en móvil, tres columnas en desktop */}
        <div className="grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-8">
          {/* Columna 1: Curvia AI y Redes - Oculta en móvil */}
          <div className="hidden md:block">
            <h3 className="text-purple-300 font-bold text-lg mb-4 border-b border-purple-500/30 pb-2">
              Curvia AI
            </h3>
            <div className="flex space-x-4 mt-4">
              <a href="https://www.instagram.com/curvia.app/" target="_blank" rel="noopener noreferrer" className="bg-purple-900/50 p-2 rounded-full hover:bg-purple-700/70 transition duration-300">
                <Instagram className="w-4 h-4 text-purple-300" />
              </a>
              <a href="https://www.tiktok.com/@curvia.ai" target="_blank" rel="noopener noreferrer" className="bg-purple-900/50 p-2 rounded-full hover:bg-purple-700/70 transition duration-300">
                <svg className="w-4 h-4 text-purple-300" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"/>
                </svg>
              </a>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="bg-purple-900/50 p-2 rounded-full hover:bg-purple-700/70 transition duration-300">
                <Linkedin className="w-4 h-4 text-purple-300" />
              </a>
            </div>
          </div>
          
          {/* Columna: Plataforma */}
          <div>
            <h3 className="text-purple-300 font-bold text-base md:text-lg mb-2 md:mb-4 border-b border-purple-500/30 pb-2">
              Plataforma
            </h3>
            <ul className="space-y-1 md:space-y-2">
              <li>
                <Link to="/" onClick={scrollToTop} className="text-purple-200/80 text-xs md:text-sm hover:text-purple-300 transition duration-300 flex items-center">
                  <span className="w-1 h-1 md:w-1.5 md:h-1.5 bg-purple-500 rounded-full mr-1 md:mr-2"></span>
                  Inicio
                </Link>
              </li>
              <li>
                <Link to="/features" onClick={scrollToTop} className="text-purple-200/80 text-xs md:text-sm hover:text-purple-300 transition duration-300 flex items-center">
                  <span className="w-1 h-1 md:w-1.5 md:h-1.5 bg-purple-500 rounded-full mr-1 md:mr-2"></span>
                  Características
                </Link>
              </li>
              <li>
                <Link to="/pricing" onClick={scrollToTop} className="text-purple-200/80 text-xs md:text-sm hover:text-purple-300 transition duration-300 flex items-center">
                  <span className="w-1 h-1 md:w-1.5 md:h-1.5 bg-purple-500 rounded-full mr-1 md:mr-2"></span>
                  Precios
                </Link>
              </li>
              <li>
                <Link to="/testimonials" onClick={scrollToTop} className="text-purple-200/80 text-xs md:text-sm hover:text-purple-300 transition duration-300 flex items-center">
                  <span className="w-1 h-1 md:w-1.5 md:h-1.5 bg-purple-500 rounded-full mr-1 md:mr-2"></span>
                  Testimonios
                </Link>
              </li>
              <li>
                <Link to="/contact" onClick={scrollToTop} className="text-purple-200/80 text-xs md:text-sm hover:text-purple-300 transition duration-300 flex items-center">
                  <span className="w-1 h-1 md:w-1.5 md:h-1.5 bg-purple-500 rounded-full mr-1 md:mr-2"></span>
                  Contacto
                </Link>
              </li>
            </ul>
          </div>
          
          {/* Columna: Recursos */}
          <div>
            <h3 className="text-purple-300 font-bold text-base md:text-lg mb-2 md:mb-4 border-b border-purple-500/30 pb-2">
              Recursos
            </h3>
            <ul className="space-y-1 md:space-y-2">
              <li>
                <Link to="/help" onClick={scrollToTop} className="text-purple-200/80 text-xs md:text-sm hover:text-purple-300 transition duration-300 flex items-center">
                  <span className="w-1 h-1 md:w-1.5 md:h-1.5 bg-blue-500 rounded-full mr-1 md:mr-2"></span>
                  Centro de ayuda
                </Link>
              </li>
              <li>
                <Link to="/account" onClick={scrollToTop} className="text-purple-200/80 text-xs md:text-sm hover:text-purple-300 transition duration-300 flex items-center">
                  <span className="w-1 h-1 md:w-1.5 md:h-1.5 bg-blue-500 rounded-full mr-1 md:mr-2"></span>
                  Mi cuenta
                </Link>
              </li>
              <li>
                <Link to="/dashboard" onClick={scrollToTop} className="text-purple-200/80 text-xs md:text-sm hover:text-purple-300 transition duration-300 flex items-center">
                  <span className="w-1 h-1 md:w-1.5 md:h-1.5 bg-blue-500 rounded-full mr-1 md:mr-2"></span>
                  Guía de uso
                </Link>
              </li>
              <li>
                <Link to="/coins" onClick={scrollToTop} className="text-purple-200/80 text-xs md:text-sm hover:text-purple-300 transition duration-300 flex items-center">
                  <span className="w-1 h-1 md:w-1.5 md:h-1.5 bg-blue-500 rounded-full mr-1 md:mr-2"></span>
                  Sistema de monedas
                </Link>
              </li>
            </ul>
          </div>
        </div>
        
        {/* Separador */}
        <div className="my-4 md:my-8 border-t border-purple-500/20"></div>
        
        {/* Sección Legal en Móvil - Movida arriba de todo */}
        <div className="mb-6 md:hidden">
          <h3 className="text-purple-300 font-bold text-base mb-3 text-center">
            Legal
          </h3>
          <div className="flex justify-center space-x-6">
            <Link to="/terms" onClick={scrollToTop} className="bg-purple-900/30 hover:bg-purple-900/50 px-4 py-2 rounded-md text-purple-200 text-xs transition-colors flex-1 text-center max-w-24">
              Términos
            </Link>
            <Link to="/privacy" onClick={scrollToTop} className="bg-purple-900/30 hover:bg-purple-900/50 px-4 py-2 rounded-md text-purple-200 text-xs transition-colors flex-1 text-center max-w-24">
              Privacidad
            </Link>
            <Link to="/cookies" onClick={scrollToTop} className="bg-purple-900/30 hover:bg-purple-900/50 px-4 py-2 rounded-md text-purple-200 text-xs transition-colors flex-1 text-center max-w-24">
              Cookies
            </Link>
          </div>
        </div>
        
        {/* Footer Bottom con copyright */}
        <div className="flex flex-col justify-center items-center">
          <p className="text-purple-200/60 text-[10px] md:text-xs mb-2 md:mb-3 text-center">
            © {new Date().getFullYear()} Curvia AI. Todos los derechos reservados.
          </p>
          
          {/* Links Legales - Solo visibles en desktop */}
          <div className="hidden md:flex flex-wrap justify-center gap-4">
            <Link to="/terms" onClick={scrollToTop} className="text-purple-200/60 text-xs hover:text-purple-300 transition-colors">
              Términos
            </Link>
            <span className="text-purple-700">•</span>
            <Link to="/privacy" onClick={scrollToTop} className="text-purple-200/60 text-xs hover:text-purple-300 transition-colors">
              Privacidad
            </Link>
            <span className="text-purple-700">•</span>
            <Link to="/cookies" onClick={scrollToTop} className="text-purple-200/60 text-xs hover:text-purple-300 transition-colors">
              Cookies
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}; 